import React from 'react';
import { useGetDashboardConsentsQuery } from '../../../api/dashboardApiSlice';
import VendorConsent from '../../metrics/VendorConsent';

const GlobalVendorConsent = ( { filter} ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetDashboardConsentsQuery({filter})
  return (
    <VendorConsent data={data} loaderProps={{isLoading, isSuccess, retry: refetch}}/>
  )
}

export default GlobalVendorConsent
